<section mat-dialog-title>
  <span class="test-title">Notes</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content>
  <avs-incident-notes [incident]="data.incident" />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    class="btn-transparent btn-medium font-bold"
    mat-dialog-close
  >
    CANCEL
  </button>
</mat-dialog-actions>
